import { SessionMessage } from '../../session-message/session-message';

export function getEvaluateGoalPrompt(sessionMessageList: SessionMessage[], goal: { description: string }) {
  let chatHistory = '';

  sessionMessageList.forEach((message) => {
    chatHistory += `Sales Rep: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `Review the conversation between the Customer and Sales Rep carefully. Assess if the Sales Rep achieved the specified goal. Provide a concise explanation for your assessment, detailing why the goal was or was not met. Consider the entire dialogue and the specific objectives outlined in the goal. In your output, you are talking to the sales rep in the conversation history. You are giving advice to the audience referred as "You".

<CONVERSATION_HISTORY>
${chatHistory}
</CONVERSATION_HISTORY>

<GOAL>
${goal.description}
</GOAL>
`;
}
